import { Button, Checkbox, Heading, Icon, IconButton, Input, Select, Stack, Table, TableContainer, Tbody, Td, Text, Textarea, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";

import { FaArrowLeft, FaArrowRight, FaCheck } from "react-icons/fa";

import { MdNotifications } from "react-icons/md";


export default function NotificationSettings() {
    const [invs] = useState([
        {
            refId: 1,
            notification: 'Account not used for 6 months'
        },
        {
            refId: 2,
            notification: 'Credits Added'
        },
        {
            refId: 3,
            notification: 'Customer Success Partner'
        },
        {
            refId: 4,
            notification: 'Monthly Document Summary'
        },
        {
            refId: 5,
            notification: 'No Document Upload after sign up for two days'
        }
    ]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={MdNotifications}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Notification Settings</Heading>
                            <Text fontSize={'sm'}>Here you can view your notification settings.</Text>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <Stack
                    w={'full'}
                    spacing={2}
                    align={'center'}
                    direction={'row'}
                    justify={'flex-end'}
                >
                    <Button
                        size={'sm'}
                        color={'white'}
                        bg={'green.500'}
                        leftIcon={<FaCheck />}
                        _hover={{ bg: 'green.600' }}
                        _active={{ bg: 'green.700' }}
                    >
                        Submit
                    </Button>
                </Stack>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'} zIndex={1}>
                            <Tr>
                                <Th
                                    color={"white"}
                                >
                                    Ref ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Notification
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Mandatory
                                </Th>
                                <Th
                                    color={"white"}
                                >
                                    Email
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Web
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Mobile
                                </Th>
                                <Th
                                    color={"white"}
                                >
                                    Receiver
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Frequency
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Day
                                </Th>
                                <Th
                                    color={"white"}
                                >
                                    Time
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Type
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Email Subject
                                </Th>
                                <Th
                                    color={"white"}
                                >
                                    Email Message
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Web Message
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Mobile Message
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.map((inv, i) => (
                                    <Tr>
                                        <Td>{inv.refId}</Td>
                                        <Td>{inv.notification}</Td>
                                        <Td>
                                            <Checkbox
                                                w={'full'}
                                                size={'sm'}
                                                colorScheme={'primary'}
                                            >
                                            </Checkbox>
                                        </Td>
                                        <Td>
                                            <Checkbox
                                                w={'full'}
                                                size={'sm'}
                                                colorScheme={'primary'}
                                            >
                                            </Checkbox>
                                        </Td>
                                        <Td>
                                            <Checkbox
                                                w={'full'}
                                                size={'sm'}
                                                colorScheme={'primary'}
                                            >
                                            </Checkbox>
                                        </Td>
                                        <Td>
                                            <Checkbox
                                                w={'full'}
                                                size={'sm'}
                                                colorScheme={'primary'}
                                            >
                                            </Checkbox>
                                        </Td>
                                        <Td>
                                            <Select
                                                w={'full'}
                                                size={'sm'}
                                            >
                                                <option value={'option1'}>Organization User</option>
                                                <option value={'option2'}>Current User</option>
                                            </Select>
                                        </Td>
                                        <Td>
                                            <Select
                                                w={'full'}
                                                size={'sm'}
                                            >
                                                <option value={'option1'}>Daily</option>
                                                <option value={'option2'}>Weekly</option>
                                                <option value={'option2'}>Monthly</option>
                                                <option value={'option2'}>Half Yearly</option>
                                                <option value={'option2'}>Yearly</option>
                                            </Select>
                                        </Td>
                                        <Td>
                                            <Input
                                                w={'full'}
                                                size={'sm'}
                                                type={'text'}
                                                placeholder={'Enter Days'}
                                            />
                                        </Td>
                                        <Td>
                                            <Input
                                                w={'full'}
                                                size={'sm'}
                                                type={'time'}
                                                placeholder={'Enter Time'}
                                            />
                                        </Td>
                                        <Td>
                                            <Select
                                                w={'full'}
                                                size={'sm'}
                                            >
                                                <option value={'option1'}>Informational</option>
                                                <option value={'option2'}>Update</option>
                                                <option value={'option2'}>Offer</option>
                                            </Select>
                                        </Td>
                                        <Td>
                                            <Textarea
                                                w={'full'}
                                                size={'sm'}
                                                resize={'none'}
                                                placeholder={'Write your email subject'}
                                            >
                                            </Textarea>
                                        </Td>
                                        <Td>
                                            <Textarea
                                                w={'full'}
                                                size={'sm'}
                                                resize={'none'}
                                                placeholder={"Write your email message"}
                                            >
                                            </Textarea>
                                        </Td>
                                        <Td>
                                            <Textarea
                                                w={'full'}
                                                size={'sm'}
                                                resize={'none'}
                                                placeholder={"Write your web message"}
                                            >
                                            </Textarea>
                                        </Td>
                                        <Td>
                                            <Textarea
                                                w={'full'}
                                                size={'sm'}
                                                resize={'none'}
                                                placeholder={"Write your mobile message"}
                                            >
                                            </Textarea>
                                        </Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}